<template>
  <div class="back_">
    <img class="top_" src="../../../assets/image/invite/invite.png" alt="">
    <div class="bott_">
      <img class="btn" src="../../../assets/image/invite/face.png" alt="" @click="handleType(1)">
      <img class="btn" src="../../../assets/image/invite/share.png" alt="" @click="handleType(2)">
      <!-- <div class="btn" @click="handleType(1)">面对面邀请</div>
      <div class="btn" @click="handleType(2)">分享邀请</div> -->
    </div>

    <div class="out_" v-if="showModel1">
      <div class="inner_">
        <p class="close_" style="margin:0;" @click="close">X</p>
        <p class=" bold_" style="margin-top: 0;text-align: center;">财务信息</p>
        <!-- <p class="txt_ bold_">
          提现方式：
          <span @click="handleChange('2', 'cashWithdrawalMethod')">
            <input
              type="radio"
              name="radio1"
              :checked="cashWithdrawalMethod == '2'"
            />
            <label>统结</label>
          </span>
          <span @click="handleChange('1', 'cashWithdrawalMethod')">
            <input
              type="radio"
              name="radio1"
              :checked="cashWithdrawalMethod == '1'"
            />
            <label>个结</label>
          </span>
        </p>
        <p class="txt_ bold_">
          是否开票：
          <span @click="handleChange('Y', 'isOpenTicket')">
            <input type="radio" name="radio2" :checked="isOpenTicket == 'Y'" />
            <label>是</label>
          </span>
          <span @click="handleChange('N', 'isOpenTicket')">
            <input type="radio" name="radio2" :checked="isOpenTicket == 'N'" />
            <label>否</label>
          </span>
        </p> -->
        <div style="padding: 0 25px;">
          <div style="color: #999999;text-align: left;margin:15px 0;">提现方式</div>
          <div style="display: flex;justify-content: space-between;">
            <div class="btn_1" @click="handleChange('2', 'cashWithdrawalMethod')" :class="{active: cashWithdrawalMethod == 2}">统结</div>
            <div class="btn_1" @click="handleChange('1', 'cashWithdrawalMethod')" :class="{active: cashWithdrawalMethod == 1}">个结</div>
          </div>
          <div style="color: #999999;text-align: left;margin:15px 0;">是否开票</div>
          <div style="display: flex;justify-content: space-between;">
            <div class="btn_1" @click="handleChange('Y', 'isOpenTicket')" :class="{active: isOpenTicket == 'Y'}">是</div>
            <div class="btn_1" @click="handleChange('N', 'isOpenTicket')" :class="{active: isOpenTicket == 'N'}">否</div>
          </div>
          <template v-if="isOpenTicket == 'Y'">
            <div style="color: #999999;text-align: left;margin:15px 0;">税率</div>
            <div style="display: flex;justify-content: space-between;">
              <div class="btn_1" @click="handleChange('0', 'texRate')" :class="{active: texRate == 0 }">0%</div>
              <div class="btn_1" @click="handleChange('6', 'texRate')" :class="{active: texRate == 6 }">6%</div>
            </div>
          </template>
        </div>
        <!-- <p class="txt_ bold_" v-if="isOpenTicket == 'Y'">
          <span style="width:73px;">税率：</span>
           <span @click="handleChange('0', 'texRate')">
            <input type="radio" name="radio3" :checked="texRate == '0'" />
            <label>0%</label>
          </span>
          <span @click="handleChange('6', 'texRate')">
            <input type="radio" name="radio3" :checked="texRate == '6'" />
            <label>6%</label>
          </span>
        </p> -->

        <!-- <div class="b_list_">
          <div class="btn_" @click="close">取消</div>
          <div class="btn_" @click="getRegisterShareParm">{{type==1?'生成二维码':'确定'}}</div>
        </div> -->
        <div class="bottom_">
          <a class="btn" @click="close">取消</a>
          <a class="btn" @click="getRegisterShareParm">{{type==1?'生成二维码':'分享邀请'}}</a>
        </div>
      </div>
    </div>

    <div class="out_" v-if="showCode">
      <div class="inner_">
        <p class="close_" @click="showCode = false">X</p>
        <vue-qr
          :text="data.shareUrl"
          :margin="0"
          colorDark="#000000"
          colorLight="#fff"
          :logoScale="0.2"
          :size="200"
          :callback="test"
        ></vue-qr>
        <p style="text-align:center;font-size: 13px;">扫描上方二维码，接收邀请</p>
      </div>
      <!-- colorDark="#f67b29" -->
          <!-- :logoSrc="data.sharePicuter + '?cache'" -->
    </div>
  </div>
</template>

<script>
import api from "@/utils/api";
import vueQr from "vue-qr";
import common from './common.js'
export default {
  components: {
    vueQr
  },
  data() {
    document.title = '邀请注册'
    return {
      isOpenTicket: "N",
      cashWithdrawalMethod: "1",
      texRate: "0",
      type:1, //1-面对面，2-分享
      showModel1: false,
      showCode: false,
      codeValue: "",
      icode: "",
      data: {
        shareUrl: "",
        sharePicuter: ""
      },
      query: {}
    };
  },
  mounted(){
    let body = document.getElementById('app')
    body.style.height = '100vh'
    body.style.overflow = 'hidden'
    this.query = this.$route.query
  },
  methods: {
    ...common,
    test(dataUrl) {
      console.log(dataUrl);
    },
    handleType(type){
      this.showModel1 = true
      this.type = type
    },
    getRegisterShareParm() {
      let data = {
        nymanager: this.query.nymanager,
        isOpenTicket: this.isOpenTicket,
        cashWithdrawalMethod: this.cashWithdrawalMethod,
        texRate: this.texRate
      };
      api.getRegisterShareParm(data).then(res => {
        this.data = res.data.content;
        this.showModel1 = false;
        this.setSession('s_',this.data)
        if(this.type === 1){
          this.showCode = true;
        } else {
          window.location.href = this.data.shareUrl
        }
      });
    },
    showToast(txt){
      this.$createToast({
        txt: txt,
        type: 'txt'
      }).show()
    },
    handleChange(id, key) {
      this[key] = id;
      console.log(key,this[key]);

      console.log(this.isOpenTicket,this.texRate,"---")
    },
    close() {
      this.showModel1 = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.back_ {
  overflow: hidden;
  // background: url("../../../assets/image/invite/invite.png") no-repeat;
  // height: 100vh;
  // width: 100vw;
  // background-size: 100% 100%;
  // position: relative;
  .top_{
    height: 100vh;
    width: 100vw;
  }
  .bott_ {
    position: absolute;
    bottom: 45px;
    left: 0;
    display: flex;
    justify-content: space-around;
    // padding: 20px;
    padding-left: 15px;
    width: 100%;
    // background: #fff;
    .btn {
      border-radius: 10px;
      width: 150px;
      height: 47px;
      color: #fff;
      background: #0079fe;
      font-size: 16px;
      text-align: center;
      line-height: 47px;
    }
  }

  .out_ {
    background: rgba(0, 0, 0, 0.6);
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    // padding: 30vh 10vw;
    font-size: 14px;
    display: flex;
    justify-content: center;
    align-items: center;
    .inner_ {
      position: relative;
      //   height: 100%;
      width: 70%;
      background: #fff;
      border-radius: 15px;
      // padding: 15px 25px;
      padding-top: 15px;
      .close_ {
        text-align: right;
        margin-top: 0;
        padding-right: 15px;
      }
      p {
        margin: 25px 0;
        text-align: left;
        span {
          width: 80px;
          display: inline-block;
        }
        label {
          margin: 0 0px 0 10px;
        }
      }
      .b_list_ {
        display: flex;
        justify-content: center;
        .btn_ {
          margin: 10px;
          color: #0079fe;
          padding: 10px 25px;
          border-radius: 10px;
        }
      }
      .btn_1 {
        width: 100px;
        height: 30px;
        border: 1px #eee solid;
        line-height: 28px;
        border-radius: 15px;
      }
      .active {
        color: #fff;
        background-color: #0079fe;
      }
      .bottom_ {
        margin-top: 30px;
        display: flex;
        justify-content: space-between;
        // position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        height: 50px;
        line-height: 50px;
        border-top: 1px #eee solid;
        .btn {
          text-align: center;
          flex: 1;
           &:first-child {
            border-right: 1px #eee solid;
          }
        }
      }
    }
  }
  .number_ {
    height: 20px;
    border-bottom: 1px solid #f5f5f5;
    padding: 10px 0;
    outline: transparent;
  }

  .active_ {
    color: #fff;
    background: #0079fe;
  }
  .blue_ {
    color: #0079fe;
  }
  .bold_ {
    font-weight: bold;
  }
}
</style>
